import { Component, OnInit, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { HeaderComponent } from '../shared/header/header.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CadastroBensService, Bens, Categoria } from '../services/cadastro-bens.service';
import { BemListagem, ListagemBensService } from '../services/listar-bens.service';

@Component({
  selector: 'app-guardian-dashboard',
  imports: [RouterModule, HeaderComponent, CommonModule, FormsModule],
  templateUrl: './guardian-dashboard.component.html',
  styleUrl: './guardian-dashboard.component.scss'
})
export class GuardianDashboardComponent implements OnInit {
  bens: BemListagem[] = [];
  bensFiltrados: BemListagem[] = [];
  categorias: Categoria[] = [];
  categoriasFiltradas: Categoria[] = [];
  carregando = false;
  mostrarFiltrosAvancados = false;

  // Dropdown categoria
  dropdownCategoriaAberto = false;
  buscaCategoria = '';
  categoriaTexto = 'Todas';

  filtros = {
    categoriaId: null as number | null,
    marcaNome: '',
    modeloNome: '',
    nomeUsuario: '',
    statusAtivo: null as boolean | null
  };

  constructor(
    private router: Router,
    private cadastroBensService: CadastroBensService,
    private listagemBensService: ListagemBensService
  ) {}

  ngOnInit() {
    this.carregarCategorias();
    this.carregarBens();
  }

  // Fecha o dropdown se clicar fora dele
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.position-relative')) {
      this.dropdownCategoriaAberto = false;
    }
  }

  // ========== DROPDOWN CATEGORIA ==========

  toggleDropdownCategoria() {
    this.dropdownCategoriaAberto = !this.dropdownCategoriaAberto;
    if (this.dropdownCategoriaAberto) {
      this.buscaCategoria = '';
      this.categoriasFiltradas = [...this.categorias];
    }
  }

  filtrarCategorias() {
    const busca = this.buscaCategoria.toLowerCase();
    this.categoriasFiltradas = this.categorias.filter(cat =>
      cat.nome.toLowerCase().includes(busca)
    );
  }

  selecionarCategoria(id: number | null, nome: string) {
    this.filtros.categoriaId = id;
    this.categoriaTexto = nome;
    this.dropdownCategoriaAberto = false;
    this.aplicarFiltros();
  }

  // ========== CARREGAR DADOS ==========

  carregarCategorias() {
    this.cadastroBensService.getCategorias().subscribe({
      next: (categorias) => {
        this.categorias = categorias;
        this.categoriasFiltradas = [...categorias];
      },
      error: (erro) => {
        console.error('Erro ao carregar categorias:', erro);
      }
    });
  }

carregarBens() {
  this.carregando = true;

  const temFiltroApi =
    this.filtros.categoriaId ||
    this.filtros.marcaNome?.trim() ||
    this.filtros.modeloNome?.trim() ||
    this.filtros.nomeUsuario?.trim();

  const request$ = temFiltroApi
    ? this.listagemBensService.listarFiltrado(
        this.filtros.categoriaId,
        this.filtros.marcaNome,
        this.filtros.modeloNome,
        this.filtros.nomeUsuario
      )
    : this.listagemBensService.listarTodos();

  request$.subscribe({
    next: (bens) => {
      this.bens = bens;
      this.aplicarFiltrosLocais(); // ainda aplica o filtro de statusAtivo localmente
      this.carregando = false;
    },
    error: (erro) => {
      console.error('Erro ao carregar bens:', erro);
      this.carregando = false;
    }
  });
}

  aplicarFiltrosLocais() {
    let resultado = [...this.bens];

    if (this.filtros.statusAtivo !== null) {
      resultado = resultado.filter(bem => bem.ativo === this.filtros.statusAtivo);
    }

    this.bensFiltrados = resultado;
  }

  aplicarFiltros() {
    this.carregarBens();
  }

  limparFiltros() {
    this.filtros = {
      categoriaId: null,
      marcaNome: '',
      modeloNome: '',
      nomeUsuario: '',
      statusAtivo: null
    };
    this.categoriaTexto = 'Todas';
    this.buscaCategoria = '';
    this.carregarBens();
  }

  toggleFiltrosAvancados() {
    this.mostrarFiltrosAvancados = !this.mostrarFiltrosAvancados;
  }

  // ========== STATUS BADGE ==========

  getStatusBadge(bem: BemListagem) {
    if (!bem.ativo) {
      return {
        class: 'bg-secondary-subtle text-secondary-emphasis',
        text: 'Baixado'
      };
    }

    if (bem.tipoCondicaoBens?.nome?.toLowerCase().includes('manutenção')) {
      return {
        class: 'bg-warning-subtle text-warning-emphasis',
        text: 'Em Manutenção'
      };
    }

    return {
      class: 'bg-success-subtle text-success-emphasis',
      text: 'Ativo'
    };
  }

  // ========== NAVEGAÇÃO ==========

  irParaCadastro() {
    this.router.navigate(['guardian/cadastro-patrimonio']);
  }

  irParaDash() {
    this.router.navigate(['/guardian/dashboard']);
  }
}